import request from '@/utils/request'

// 查询列表
export function apiScpMrpShortageSummarySupplierList (data) {
  return request({
    url: '/scp/scpMrpShortageSummary/supplierList',
    method: 'post',
    data: data
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansCallMaterialPlanExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/callMaterialPlanExecutionTime',
    method: 'get',
    params: query
  })
}

// 动态表头
export function apiScpMrpShortageDatesDateDisplayList (query) {
  return request({
    url: '/scp/scpMrpShortageDates/dateDisplayList',
    method: 'get',
    params: query
  })
}

// 计划版本
export function apiScpMrpPlansPlanVersionBox (query) {
  return request({
    url: '/scp/scpMrpPlans/planVersionBox',
    method: 'get',
    params: query
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}
